export function scrollToLocation(id) {
  document.getElementById(id).scrollIntoView({ behavior: 'smooth' });;
}

export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive 
}